<div class="popup-header">
  <div class="title">
    Import
  </div>
  <div class="top-bar-buttons">
    <mat-icon (click)="downloadCurrentTable()" *ngIf="dataSource;" class="top-bar-button"
      matTooltip="Download current table">save_alt</mat-icon>

    <label class="custom-file-upload top-bar-button">
      <input type="file" id="importfile" (change)="onFileChange($event)"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
      <mat-icon matTooltip="Import">vertical_align_top</mat-icon>
    </label>

    <mat-icon (click)="addColumn()" class="top-bar-button" matTooltip="Add Column">add</mat-icon>

  </div>
</div>
<br>
<div mat-dialog-content #TABLE>
  <p>
    Required header names :
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
      <mat-button-toggle *ngFor="let obj of data.requiredColumn">{{obj.name}}</mat-button-toggle>
    </mat-button-toggle-group>
  </p>
  <p *ngIf="data.groups && data.groups.length">
    Optional "group" column — type one of this site's group names exactly (case-insensitive; leave blank for no group):
    <mat-button-toggle-group name="groupNames" aria-label="Group names">
      <mat-button-toggle *ngFor="let g of data.groups">{{ g.name || g.groupId }}</mat-button-toggle>
    </mat-button-toggle-group>
  </p>

  <mat-chip-listbox aria-label="Fish selection" *ngIf="dataSource">
    Removeables:
    <mat-chip-option color="accent" matTooltip="Remove column from table" *ngFor="let columnSetting of getKeys();">
      {{columnSetting}}
      <mat-icon matChipRemove (click)="delete(columnSetting)">cancel</mat-icon>
    </mat-chip-option>
  </mat-chip-listbox>
  <br>
  <ng-container *ngIf="dataSource; else import">
    <table mat-table  [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container *ngFor="let columnSetting of getKeys();" [matColumnDef]="columnSetting">
        <th class="gray" mat-header-cell *matHeaderCellDef  contenteditable='true'>
          {{columnSetting}}
        </th>
        <td mat-cell *matCellDef="let element" contenteditable='true' (blur)="onBlur(element,columnSetting)">
          {{element[columnSetting]}}
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
  </ng-container>
  <ng-template #import>
    <div class="selection-file-container">
      <div class="selection-file">
        Select <a class="file" (click)="openFile()" href="javascript:void(0);">file</a> or download <a class="file"
          (click)="downloadTemplate()" href="javascript:void(0);">template</a>
      </div>
    </div>
  </ng-template>
</div>

<div mat-dialog-actions align="end">
  <button  mat-raised-button (click)="downloadTemplate()">Download Template</button>
  <div class="fx-spacer"></div>
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <button class="theme-button" (click)="export()"  *ngIf="dataSource;" cdkFocusInitial>Upload</button>
</div>
